module.exports = __webpack_public_path__ + "static/media/answer.01f4fcdc.png";